import withDraft from '@/utils/draftHelper';
import { updateUsergroupActions } from '@/users/groups/constants';
import { updateAuditName } from './state';

const updateUserGroupName = withDraft((draft, { code, result: { name } }) => {
  updateAuditName(draft, 'usergroup', code, name);
});

export default {
  [updateUsergroupActions.UPDATE_USERGROUP_SUCCESS]: updateUserGroupName,
};
